export const getUserType = () => {
	const user = localStorage.getItem("vr_auth");
	if (!user) return null;
	const { userType } = JSON.parse(user);

	return userType;
};
